export const LOADSHIFT_MEMBERSHIP_PACKAGE_NAME_OLD = 'loadshift_membership';
export const LOADSHIFT_MEMBERSHIP_PACKAGE_NAME_V1 = 'loadshift_membership_v1';
export const LOADSHIFT_MEMBERSHIP_PACKAGE_NAME_V2 = 'loadshift_v2';
export const LOADSHIFT_MEMBERSHIP_PACKAGE_NAME_V3 = 'loadshift_v3';

export const LOADSHIFT_MEMBERSHIP_FREE_TRIAL_PACKAGE_NAME_V1 =
  'loadshift_membership_free_trial_v1';
export const LOADSHIFT_MEMBERSHIP_FREE_TRIAL_PACKAGE_NAME_V2 =
  'loadshift_free_trial_v2';
export const LOADSHIFT_MIGRATED_MEMBERSHIP_PACKAGE_NAME =
  'loadshift_membership_migrated';
